import * as React from 'react'
import { ExternalLink } from '@sales-center/components'
import { useGetLocationUrl } from '@user/store/authorization'

type Props = {
  locationId: string
  locationCode: string
  icon?: string
}

export function ServiceLocationLink(props: Props) {
  const { locationId, locationCode, icon } = props

  const href = useGetLocationUrl(locationId, false)

  return (
    <ExternalLink
      label={locationCode}
      href={href}
      icon={icon}
      dataTestId={`serviceLocationLink-${locationCode}`}
    />
  )
}
